import { render, staticRenderFns } from "./HandlingHeader.vue?vue&type=template&id=675cc2b4&"
import script from "./HandlingHeader.vue?vue&type=script&lang=js&"
export * from "./HandlingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports